(function () {
  function set_expanded(item, expanded) {
    var trigger = item.querySelector(':scope > .header__link, :scope > label > .header__link');
    if (!trigger) return;

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function open_menu(item) {
    item.classList.add('is-opened');
    set_expanded(item, true);
  }

  function close_menu(item) {
    item.classList.remove('is-opened');
    set_expanded(item, false);
  }

  function init() {
    document.querySelectorAll('.navbar-item.has-dropdown').forEach(function (item) {
      var trigger = item.querySelector(':scope > .header__link, :scope > label > .header__link');
      if (!trigger) return;

      set_expanded(item, item.classList.contains('is-opened'));
      if (item.dataset.a11yNavigationBound === '1') return;
      item.dataset.a11yNavigationBound = '1';

      if (trigger.tagName === 'A' && !trigger.hasAttribute('href')) {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
      }

      item.addEventListener('focusin', function () {
        open_menu(item);
      });

      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) close_menu(item);
        }, 0);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          close_menu(item);
          trigger.focus();
          return;
        }

        if (event.key === 'ArrowDown' || ((event.key === 'Enter' || event.key === ' ') && !trigger.hasAttribute('href'))) {
          event.preventDefault();
          open_menu(item);

          var first_link = item.querySelector('.navbar-dropdown a, .navbar-dropdown button');
          if (first_link) first_link.focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.navbar-item.has-dropdown')) return;
      document.querySelectorAll('.navbar-item.has-dropdown.is-opened').forEach(close_menu);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
